export default function querify(obj) {
  // Make sure we don't alter integers.
  if (typeof obj === 'number') {
    return obj;
  }

  // Stringify everything other than objects.
  if (typeof obj !== 'object') {
    return JSON.stringify(obj);
  }

  if (Array.isArray(obj)) {
    return `[${obj.map(querify)}]`;
  }

  // Iterate through object keys to convert into a string
  // to be interpolated into the query.
  const props = Object.keys(obj).map((key) => `${key}:${querify(obj[key])}`).join(',');

  return `{${props}}`;
}
